<template>
  <div class="shadow-sm bg-white p-4 rounded">
    <div class="row gutters-5">
      <div v-for="(item, index) in list" :key="index" class="col-md-6 mb-3">
        <label class="aiz-megabox d-block bg-white mb-0">
          <input
            v-if="selectable"
            v-model="selectedAddressIndex"
            :value="index"
            name="address_id"
            type="radio"
          />
          <span class="d-flex p-3 aiz-megabox-elem">
            <span
              v-if="selectable"
              class="aiz-rounded-check flex-shrink-0 mt-1"
            ></span>
            <span class="flex-grow-1 pl-3 text-left">
              <div v-for="[key, name] in keyList" :key="key">
                <span class="opacity-60"> {{ $t(name) }}:</span>
                <span class="fw-600 ml-2">{{ item[key] }}</span>
              </div>
              <div
                v-if="item.isDefault"
                class="position-absolute right-0 bottom-0 pr-2 pb-3"
              >
                <span class="badge badge-inline badge-primary">{{
                  $t("默认")
                }}</span>
              </div>
            </span>
          </span>
        </label>
        <div class="dropdown position-absolute right-0 top-0 show">
          <PopoverComp>
            <template #button>
              <button class="btn bg-gray px-2" type="button">
                <i class="la la-ellipsis-v"></i>
              </button>
            </template>
            <template #popover>
              <div
                class="dropdown-menu dropdown-menu-right show"
                style="
                            position: absolute;
                            transform: translate3d(-192px, 42px, 0px);
                            top: 0;
                            left: 0;
                            will-change: transform;
                          "
              >
                <a class="dropdown-item" @click="editAddress({ ...item })">
                  {{ $t("编辑") }}
                </a>
                <a class="dropdown-item" @click="deleteAddress(item, index)">
                  {{ $t("删除") }}
                </a>
              </div>
            </template>
          </PopoverComp>
        </div>
      </div>
      <div class="col-md-6 mx-auto mb-3">
        <div
          class="border p-3 rounded mb-3 c-pointer text-center bg-white h-100 d-flex flex-column justify-content-center"
          @click="addNewAddress"
        >
          <i class="las la-plus la-2x mb-3"></i>
          <div class="alpha-7">{{ $t("添加新地址") }}</div>
        </div>
      </div>
    </div>

    <NewAddress ref="newAddress" @save="onSaveAddress" />
  </div>
</template>
<script>
import PopoverComp from "@/components/PopoverComp.vue";
import NewAddress from "@/components/NewAddress.vue";
import { del, getList } from "@/api/user.address";

export default {
  props: {
    selectable: Boolean
  },
  components: {
    PopoverComp,
    NewAddress
  },
  data() {
    return {
      show: false,
      list: [],
      keyList: [
        ["receiver", "收货人"],
        ["phone", "电话号码"],
        ["postalCode", "邮政编码"],
        ["province", "省份"],
        ["city", "城市"],
        ["district", "地区"],
        ["addressDetail", "地址"]
      ],
      selectedAddressIndex: null,
      showPopover: false
    };
  },
  computed: {
    selectedAddress() {
      return this.list[this.selectedAddressIndex];
    }
  },
  methods: {
    async getList() {
      let data = (await getList()).data;
      this.list = data || [];
      this.selectedAddressIndex = this.list.findIndex(item => item.isDefault);
    },
    addNewAddress() {
      this.$refs.newAddress.show();
    },
    editAddress(addressInfo) {
      this.$refs.newAddress.show(addressInfo);
    },
    deleteAddress(addressInfo, index) {
      del(addressInfo.id);
      this.list.splice(index, 1);
    },
    onSaveAddress() {
      this.getList();
    }
  },
  created() {
    this.getList();
  }
};
</script>
